<template>
    <path d="M12.000001,4.3c-9.828,0 -10,0.874 -10,7.7s0.172,7.7 10,7.7s10,-0.874 10,-7.7s-0.172,-7.7 -10,-7.7zm3.205,8.034l-4.49,2.096c-0.393,0.182 -0.715,-0.022 -0.715,-0.456l0,-3.948c0,-0.433 0.322,-0.638 0.715,-0.456l4.49,2.096c0.393,0.184 0.393,0.484 0,0.668z"/>
</template>

<script>
    export default {
        name: 'youtube',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Youtube.vue